import Immutable from 'immutable'
import _get from 'lodash/get'

const NORMALIZED_FALLBACK_COLOR = 'E1EEF5'
const NORMALIZED_COLORS = {
  'FF876B': 'FEFAB5',
  '13CB6E': 'FFEDE8',
  '00E0FF': 'E2FEDF',
  '2D8EFF': 'E2FEDF',
  'EA81FF': 'D8FBFF',
  '7695A5': 'D8F0F3',
  'E95330': 'D8EBFF',
  '1F9A57': 'D8EBFF',
  '009AB0': 'FBF0FD',
  '0960C5': 'EFEEFC',
  'A60087': 'E1EEF5',
  '394F5A': 'E1EEF5',
  'EFEEFC': 'EFEEFC'
}

export const getNormalizedTagColor = (tagColor) => {
  const normalizedTagColor = NORMALIZED_COLORS[tagColor]
  return normalizedTagColor ? normalizedTagColor : NORMALIZED_FALLBACK_COLOR
}

/**
 * Returns a copy of the original tag with a normalized color value
 */
export const normalizeColor = (tag) => {
  if (tag && tag.color) {
    const normalizedColor = getNormalizedTagColor(tag.color)

    if (Immutable.Iterable.isIterable(tag)) {
      return tag.set('color', normalizedColor)
    } else {
      return Object.assign({}, tag, { color: normalizedColor })
    }
  }

  return tag
}



// WEBPACK FOOTER //
// ./src/scripts/utils/TagAppearanceHelper.js